import type { TFunction } from 'i18next'
import type { Entitlement, GateStatus, XeroInvoiceState } from '../../../types'

export const FINGERPRINT_DISPLAY_LENGTH = 8

export function getGateStatus(passed: boolean): GateStatus {
  return passed ? 'passed' : 'pending'
}

export function getActivationStatus(entitlement: Entitlement): GateStatus {
  return entitlement.status === 'active' ? 'passed' : 'pending'
}

export function buildPaymentDetail(state: XeroInvoiceState | null | undefined): string | undefined {
  if (!state) return undefined
  return `${state.invoiceStatus} - ${state.currencyCode} ${state.amountPaid.toFixed(2)}`
}

interface LicenseDetailArgs {
  fingerprint: string | null | undefined
  t: TFunction
}

export function buildLicenseDetail({ fingerprint, t }: LicenseDetailArgs): string | undefined {
  if (!fingerprint) return undefined
  return `${t('dualGate.license')} ${fingerprint.slice(0, FINGERPRINT_DISPLAY_LENGTH)}...`
}
